import { render, staticRenderFns } from "./AsignacionCurso.vue?vue&type=template&id=1d2f3348&scoped=true"
import script from "./AsignacionCurso.vue?vue&type=script&lang=js"
export * from "./AsignacionCurso.vue?vue&type=script&lang=js"
import style0 from "./AsignacionCurso.vue?vue&type=style&index=0&id=1d2f3348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f3348",
  null
  
)

export default component.exports